import React, { Component } from 'react';
import Header from './../common/Header';
import { Button, Card } from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import TimePicker from 'react-bootstrap-time-picker';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { eventNameChange, eventDescriptionChange, eventLinkChange, eventMessageChange } from '../../actions/Events/EventAction';

class AddEvents extends Component {

    constructor(props) {
        super(props);

        this.handleEvent = this.handleEvent.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);

        this.state = {
            startDate: moment(),
            time: 0,
            file: ''
        };
    }

    onEventNameChange(event) {
        this.props.eventNameChange(event);
    }

    onEventDescriptionChange(event) {
        this.props.eventDescriptionChange(event);
    }

    onEventLinkChange(event) {
        this.props.eventLinkChange(event);
    }

    // onEventTimeChange(event) {
    //     this.props.eventTimeChange(event);
    // }

    onEventMessageChange(event) {
        this.props.eventMessageChange(event);
    }

    handleEvent(event, picker) {
        this.setState({
            startDate: picker.startDate
        });
    }

    handleTimeChange(time) {
        this.setState({ time });
    }

    handleChangeFile(event) {
        const file = event.target.files[0];
        this.setState({ file });
        //Make a request to server
    }

    render() {
        console.log(this.state.file);
        const label = this.state.startDate.format('DD-MM-YYYY');
        const locale = {
            format: 'YYYY-MM-DD',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        return (
            <div>
                <Header />
                <div style={{ padding: 30, width: '100%', paddingTop: 40 }}>
                    <Card style={styles.cardStyle}>
                        <div className="row">
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Event Name
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={this.props.eventName}
                                        onChange={event => this.onEventNameChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Event Description
                                    </h6>
                                    <textarea
                                        style={styles.textAreaStyle}
                                        value={this.props.eventDescription}
                                        onChange={event => this.onEventDescriptionChange(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: 20 }}>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Event Link
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={this.props.eventLink}
                                        onChange={event => this.onEventLinkChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="row">
                                    <div className="col-xs-6 col-md-4">
                                       <div>
                                          <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                                Event Date
                                          </h6>
                                          <DateRangePicker
                                              singleDatePicker
                                              showDropdowns
                                              locale={locale}
                                              startDate={this.state.startDate}
                                              onEvent={this.handleEvent}
                                          >
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={label}
                                                    readOnly
                                                    style={styles.dateInputStyle}
                                                />
                                               <span className="input-group-btn" style={styles.dateSpanStyle}>
                                                  <Button className="default date-range-toggle" style={styles.dateButtonStyle}>
                                                     <i className="fa fa-calendar" />
                                                  </Button>
                                               </span>
                                            </div>
                                          </DateRangePicker>
                                    </div>
                                </div>
                                    <div className="col-xs-6 col-md-4">
                                        <div>
                                            <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                                Event Time
                                            </h6>
                                            {/* <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.props.eventTime}
                                                    onChange={event => this.onEventTimeChange(event.target.value)}
                                                    style={{ backgroundColor: '#fff', color: '#808080', fontFamily: 'Source Sans Pro-SemiBold', textAlign: 'center', boxShadow: 'none' }} />
                                               <span className="input-group-btn" style={{ backgroundColor: '#44B31F', borderRadius: 0, border: '#ced4da' }}>
                                                  <Button className="default date-range-toggle" style={{ backgroundColor: '#44B31F', borderRadius: 0, border: '#ced4da', boxShadow: 'none' }}>
                                                     <i className="fa fa-clock-o" />
                                                  </Button>
                                               </span>
                                            </div> */}
                                            <TimePicker
                                                onChange={this.handleTimeChange}
                                                value={this.state.time}
                                                style={styles.timeInputStyle}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: 20 }}>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Message for this Event
                                    </h6>
                                    <textarea
                                        style={styles.textAreaStyle}
                                        value={this.props.eventMessage}
                                        onChange={event => this.onEventMessageChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                    Select Event Picture
                                </h6>
                                <input
                                    type="file"
                                    onChange={this.handleChangeFile.bind(this)}
                                    style={{ fontFamily: 'Source Sans Pro', fontSize: 16 }}
                                />
                            </div>
                        </div>
                        <div style={{ paddingTop: 20 }}>
                            <Button style={styles.buttonStyle}>
                                Submit & Publish
                            </Button>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

const styles = {
    inputStyle: {
        width: '75%',
        height: 40,
        paddingLeft: 20,
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px',
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        borderRadius: '0.25rem'
    },
    textAreaStyle: {
        width: '75%',
        height: 60,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    cardStyle: {
        borderColor: '#7ed321',
        padding: 30,
        width: '90%',
        margin: 'auto',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    buttonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    dateInputStyle: {
        backgroundColor: '#fff',
        color: '#808080',
        fontFamily: 'Source Sans Pro-SemiBold',
        textAlign: 'center',
        boxShadow: 'none'
    },
    dateSpanStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da'
    },
    dateButtonStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da',
        boxShadow: 'none'
    },
    timeInputStyle: {
        backgroundColor: '#fff',
        color: '#808080',
        fontFamily: 'Source Sans Pro-SemiBold',
        textAlign: 'center',
        boxShadow: 'none'
    }
};

function mapStateToProps(state) {
    return {
        eventName: state.event.eventName,
        eventDescription: state.event.eventDescription,
        eventLink: state.event.eventLink,
        // eventTime: state.event.eventTime,
        eventMessage: state.event.eventMessage
    };
}

export default connect(mapStateToProps, { eventNameChange, eventDescriptionChange, eventLinkChange, eventMessageChange })(AddEvents);



// WEBPACK FOOTER //
// ./src/components/Events/AddEvents.js